module.exports = "/_next/static/images/alerts@3x-3837145dd1b43220891d02ce35b71070.png";